import * as React from "react";
export default class Loader extends React.Component {
    constructor(props) {
        super(props);
    }
    render() {
        return (React.createElement("div", { id: "floatingCirclesG" },
            React.createElement("div", { className: "f_circleG", id: "frotateG_01" }),
            React.createElement("div", { className: "f_circleG", id: "frotateG_02" }),
            React.createElement("div", { className: "f_circleG", id: "frotateG_03" }),
            React.createElement("div", { className: "f_circleG", id: "frotateG_04" }),
            React.createElement("div", { className: "f_circleG", id: "frotateG_05" }),
            React.createElement("div", { className: "f_circleG", id: "frotateG_06" }),
            React.createElement("div", { className: "f_circleG", id: "frotateG_07" }),
            React.createElement("div", { className: "f_circleG", id: "frotateG_08" })));
    }
}
;
//# sourceMappingURL=loader.js.map